import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import styles from './DiffItem.scss'

const CROP_WIDTH = 300
const CROP_HEIGHT = 300
const ZOOM_RATIO_TEN_X = 2
const ZOOM_RATIO_FOUR_X = 5

class DiffItem extends React.Component {
  static defaultProps = {
    width: 100,
    keypoint: {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      note: 'wbc'
    },
    image: null,
    onUpdateKeypoint: _.noop
  }

  static propTypes = {
    width: PropTypes.number,
    keypoint: PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number,
      width: PropTypes.number,
      height: PropTypes.number,
      note: PropTypes.string
    }),
    image: PropTypes.string,
    onUpdateKeypoint: PropTypes.func
  }

  constructor (props) {
    super(props)
    this.state = {
      label: props.keypoint.note,
      saved: false,
      contrast: 1
    }
  }

  updateLabel = (e) => {
    this.setState({
      label: e.target.value
    })
  }

  updateKeypoint = () => {
    const { image, keypoint } = this.props
    const { label } = this.state
    this.props.onUpdateKeypoint(image, keypoint, label)
    this.setState({
      saved: true
    })
  }

  setLabel = (newLabel) => {
    this.setState({
      label: newLabel
    }, () => {
      this.updateKeypoint()
    })
  }

  toggleContrast = () => {
    const newContrast = this.state.contrast === 2 ? 1 : 2
    this.setState({
      contrast: newContrast
    })
  }

  labelKeypoint = (e) => {
    const { image, keypoint } = this.props
    const keyToLabelMap = {
      'n': 'wbc_p_n',
      'e': 'wbc_p_e',
      'l': 'wbc_m_l',
      'm': 'wbc_m_m',
      'u': 'wbc_u',
      'w': 'wbc',
      'a': 'wbc_m_l_ab',
      'b': 'wbc_m_l_blast',
      'p': 'plt_agg'
    }
    const label = keyToLabelMap[e.key]
    if (label) {
      this.props.onUpdateKeypoint(image, keypoint, label)
      .then(() => {
        this.setState({
          saved: true,
          label
        })
      })
    }
  }

  render () {
    const { image, keypoint, width } = this.props
    const { x, y } = keypoint
    const { label, saved, contrast } = this.state
    const possibleLabels = [
      'wbc_m_l',
      'wbc_m_m',
      'wbc_p_n',
      'wbc_p_e',
      'wbc',
      'wbc_u',
      'wbc_m_l_ab',
      'plt_agg',
      'nrbc'
    ]

    const buttonClasses = [
      'btn-primary',
      'btn-secondary',
      'btn-info',
      'btn-warning',
      'btn-outline-primary',
      'btn-outline-primary',
      'btn-outline-secondary',
      'btn-outline-info',
      'btn-outline-warning',
    ]

    const zoomRatio = width > 3000 ? ZOOM_RATIO_FOUR_X : ZOOM_RATIO_TEN_X

    return (
      <div
        className='container'
        tabIndex='0'
        onKeyUp={this.labelKeypoint}
      >
        <div className='crop-container'>
          <img
            src={image}
            style={{
              marginLeft: -zoomRatio * x + CROP_WIDTH / 2,
              marginTop: -zoomRatio * y + CROP_HEIGHT / 2,
              width: width * zoomRatio,
              filter: `contrast(${contrast})`
            }}
          />
        </div>
        <div className='label-container'>
          <div className='form-group'>
            <input
              type='text'
              className='form-control'
              value={label}
              onChange={this.updateLabel}
            />
            {
              _.map(possibleLabels, (possibleLabel, i) => (
                <button
                  key={possibleLabel}
                  className={`btn ${buttonClasses[i]} button`}
                  onClick={(e) => this.setLabel(possibleLabel)}
                >
                  {possibleLabel}
                </button>
              ))
            }
            <button
              className={`btn ${saved ? 'btn-success' : 'btn-danger'} button`}
              onClick={this.updateKeypoint}
            >
              Save
            </button>
          </div>
        </div>
        <div className='controls'>
          <button
            onClick={(e) => this.toggleContrast()}
          >
            Contrast
          </button>
        </div>
        <hr />
      </div>
    )
  }
}

export default DiffItem



// WEBPACK FOOTER //
// ./src/routes/Images/components/DiffItem.js